import React from 'react'
import Tabs from '../../generic/tabs'
import PrimaryNavigationMechanical from './PrimaryNavigationMechanical'
import PrimaryTab from './PrimaryTab'
import { QuestionUtils } from '../../../utils/siteUtils'
import { ExteriorPageNumber, InteriorPageNumber, MechanicalPageNumber } from '../../../constants'
import { pageObject } from '../../../constants/pageObject'
import { CONDITION_TABS } from '../../../analytics/platforms/pixall/pageId'

const EXTERIOR_ITEMS = ['Front', 'Driver', 'Rear', 'Passenger', 'Windows']
const INTERIOR_ITEMS = ['Seats', 'Dashboard']

export default ({
  bodyStyle,
  model,
  secondaryTabExterior,
  setSecondaryTabExterior,
  secondaryTabInterior,
  setSecondaryTabInterior,
  conditionQuestions,
  make,
  tab,
  setTab,
  badgeCnt,
  setBadgeCnt,
  addImpressions,
  exteriorDoorCount,
  interiorSeatRows,
  updateGlobalState,
  ...props
}) => {
  const { anyAnswered } = props
  const onClickTab = activeTab => {
    setTab(activeTab)
    pushAnalytics(activeTab)
  }

  const pushAnalytics = activeTab => {
    let svgItems
    let svgIcons
    let movedQuestions
    const analytics = []
    addImpressions && addImpressions(analytics)
    
    const dataLayer = window.ICO.dataLayer
    if (dataLayer) {
      dataLayer.pageInfo.conditionTab = CONDITION_TABS[tab.toLowerCase()]
    }
    
    switch (tab) {
      case 'Exterior':
        svgItems = ['DriverSide' + exteriorDoorCount, 'Rear', 'PassengerSide' + exteriorDoorCount, 'FrontWithGrille', 'GlassLights' + interiorSeatRows]
        svgIcons = ['Tires & Rims', 'Brakes']
        updateGlobalState({ fireAnalytics: 'continue', cp: ExteriorPageNumber, np: pageObject[activeTab] })
        break
      case 'Interior':
        svgItems = ['Interior' + interiorSeatRows]
        svgIcons = ['ABS', 'Airbags', 'Check Engine', 'Service Engine', 'Low Coolant', 'Maintenance', 'Oil Pressure']
        movedQuestions = ['Odors']
        updateGlobalState({ fireAnalytics: 'continue', cp: InteriorPageNumber, np: pageObject[activeTab] })
        break
      case 'Mechanical':
        svgIcons = ['Engine', 'Transmission', 'Steering', 'Exhaust', 'Suspension', 'Heating/Air Conditioning', 'Battery/Electrical', 'Stereo', 'Odometer', 'Sunroof/Moonroof', 'Airbags_mech', 'Frame/Structural']
        updateGlobalState({
          fireAnalytics: 'continue',
          cp: MechanicalPageNumber,
          np: pageObject[activeTab]
        })
        break
      default:
        return
    }

    svgItems &&
      svgItems.reduce((acc, cur) => {
        const svgFound = conditionQuestions.find(question => question.subsectionCode && cur.toLowerCase().includes(question.subsectionCode))
        const svgSubSectionCode = (svgFound || {}).subsectionCode || '' // this lets us get around multiple seats issues
        const svgAnyAnswered = anyAnswered(QuestionUtils.getAssociatedQuestions(conditionQuestions, '', svgSubSectionCode))

        analytics.push({ key: svgSubSectionCode, value: svgAnyAnswered })

        return acc || svgAnyAnswered
      }, false)
    svgIcons &&
      svgIcons.reduce((acc, cur) => {
        const iconFound = conditionQuestions.find(question => question.subsectionCode && question.item.toLowerCase().startsWith(svgIcons[0].toLowerCase()))
        const iconSubSectionCode = (iconFound || {}).subsectionCode || '' // this lets us get around multiple seats issues
        const iconAnyAnswered = anyAnswered(QuestionUtils.getAssociatedQuestions(conditionQuestions, cur, iconSubSectionCode))

        analytics.push({ key: cur, value: iconAnyAnswered })

        return acc || iconAnyAnswered
      }, false)
    movedQuestions &&
      movedQuestions.reduce((acc, cur) => {
        const questionFound = conditionQuestions.find(question => question.item.toLowerCase().startsWith(movedQuestions[0].toLowerCase()))
        const questionSubSectionCode = (questionFound || {}).subsectionCode || ''
        const questionAnyAnswered = anyAnswered(QuestionUtils.getAssociatedQuestions(conditionQuestions, cur, questionSubSectionCode))

        analytics.push({ key: cur, value: questionAnyAnswered })

        return acc || questionAnyAnswered
      }, false)
  }

  const makeName = make.displayName
  const modelName = model.displayName

  const tabProps = {
    model: modelName,
    make: makeName,
    bodyStyle,
    addImpressions,
    updateGlobalState,
    pushAnalytics,
    badgeCnt,
    setBadgeCnt,
    anyAnswered,
    conditionQuestions
  }

  return (
    <>
      <Tabs activeTab={tab} onClickTabItem={onClickTab} displayArrow={true} make={makeName} model={modelName}>
        <PrimaryTab {...props} {...tabProps} testId={`vc-tab-exterior`} label="Exterior" subNavItems={EXTERIOR_ITEMS} secondaryTab={secondaryTabExterior} setSecondaryTab={setSecondaryTabExterior} />
        <PrimaryTab {...props} {...tabProps} testId={`vc-tab-interior`} label="Interior" subNavItems={INTERIOR_ITEMS} secondaryTab={secondaryTabInterior} setSecondaryTab={setSecondaryTabInterior} />
        <PrimaryNavigationMechanical testId={`vc-tab-mechanical`} label="Mechanical" conditionQuestions={conditionQuestions} props={props} pushAnalytics={pushAnalytics} />
      </Tabs>
    </>
  )
}
